import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useActiveLocale } from "../lib/i18n";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const locale = useActiveLocale();
  const { pathname, search } = useLocation();
  if (user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-700 border-t-red-600" />
      </div>
    );
  }
  if (user === false) return <Navigate to={`/${locale}/login?redirect=${encodeURIComponent(pathname + search)}`} replace />;
  return children;
}
